import React, {useEffect, useState} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import type {RowSelectionModel} from 'components/dataTable/types';
import {useLocalization} from 'localization';
import {useGetNorafUpdatesIgnorelistQuery} from 'services/agent';
import {FlexBox, Spacer} from 'components';
import {Table} from 'schema';
import {useColumnConfigState} from 'schema/table/hooks/useColumnConfigState';
import {norafUpdateIgnorelistItemSchema} from '../functions/norafUpdateIgnorelistItemSchema';
import {norafUpdateIgnorelistItemTableConfig} from '../functions/norafUpdateIgnorelistItemTableConfig';
import {NorafIgnoredListSelectionAction} from './NorafIgnoredListSelectionActions';

export const NorafIgnoredList = () => {
  const {t} = useLocalization();
  const {data, status, refetch} = useGetNorafUpdatesIgnorelistQuery();

  const {resetPaginationModel} = useColumnConfigState(
    norafUpdateIgnorelistItemSchema.name,
  );

  useEffect(() => {
    resetPaginationModel();
  }, [resetPaginationModel]);

  const [selection, setSelection] = useState<RowSelectionModel>({
    type: 'include',
    ids: new Set(),
  });

  return (
    <FlexBox>
      <Spacer height={2} />
      <Table
        schema={norafUpdateIgnorelistItemSchema}
        data={data ?? []}
        configuration={norafUpdateIgnorelistItemTableConfig}
        loading={status === QueryStatus.pending}
        header={t('page.agents.noraf.ignores.title')}
        selection={selection}
        onSelectionChanged={setSelection}
      />

      <Spacer height={2} />

      <NorafIgnoredListSelectionAction
        selection={selection}
        postProcessing={() => {
          refetch();
        }}
        postSuccess={() => {
          setSelection({
            type: 'include',
            ids: new Set(),
          });
        }}
      />
    </FlexBox>
  );
};
